export default function random() {
  const code = `RS-${(+new Date()).toString(36).slice()}`;
  return code;
}

export async function fixFinancialValue(num) {
  return Number(Number.parseFloat(num).toFixed(2));
}



// WEBPACK FOOTER //
// ./src/utils/random.js